import { motion } from "framer-motion";
import { MENU_CATALOG } from "../../data/site";
import { EASE } from "../../lib/motion";

const LINES = [
  [{ t: "THE MENU, ", c: "paper" }, { t: "DECODED.", c: "labyellow" }],
];

export const MenuHero = () => {
  return (
    <section data-testid="menu-hero" className="bg-deepred pt-24 pb-10 sm:pt-28">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-5 flex items-center justify-between"
        >
          <span className="font-mono text-[11px] uppercase tracking-[0.35em] text-labyellow">
            THE MENU // NEW JERSEY
          </span>
          <span className="hidden font-mono text-[11px] uppercase tracking-[0.35em] text-paper/50 sm:block">
            TESTED &amp; APPROVED
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="grid w-full overflow-hidden rounded-[28px] bg-labred md:grid-cols-[1.05fr_0.95fr]"
        >
          <div className="flex flex-col justify-center px-7 py-12 sm:px-12 sm:py-16 lg:px-16 lg:py-20">
            <span className="mb-6 inline-flex w-fit items-center gap-2 rounded-full border border-paper/30 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.3em] text-paper/80">
              <span className="h-1.5 w-1.5 rounded-full bg-labyellow" />
              The Full Formula
            </span>

            <h1 className="font-display text-4xl leading-[0.98] tracking-tight sm:text-5xl lg:text-6xl">
              {LINES.map((line, li) => (
                <span key={li} className="block overflow-hidden">
                  <motion.span
                    className="block"
                    initial={{ y: "110%" }}
                    animate={{ y: "0%" }}
                    transition={{ delay: 0.3, duration: 0.85, ease: EASE }}
                  >
                    {line.map((seg, si) => (
                      <span key={si} className={seg.c === "labyellow" ? "text-labyellow" : "text-paper"}>
                        {seg.t}
                      </span>
                    ))}
                  </motion.span>
                </span>
              ))}
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.6 }}
              className="mt-6 max-w-md font-body text-base leading-relaxed text-paper/90"
            >
              Every item is engineered, field-tested, and locked. Flavors are final — prices are in
              their last round of calibration.
            </motion.p>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.9, duration: 0.6 }}
              className="mt-9 flex items-center gap-6 font-mono text-[11px] uppercase tracking-[0.3em] text-paper/70"
            >
              <span className="text-labyellow">{MENU_CATALOG.length} FORMULAS</span>
              <span>6 CATEGORIES</span>
              <span className="hidden sm:inline">IN FINAL TESTING</span>
            </motion.div>
          </div>

          <div className="relative min-h-[280px] overflow-hidden md:min-h-[520px]">
            <motion.img
              src={MENU_CATALOG[0].img}
              alt="Chicken Labb signature bucket"
              initial={{ scale: 1.12 }}
              animate={{ scale: 1 }}
              transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
